import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEye, faArrowUp, faArrowDown, faFileAlt, faDownload } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './PedidosData.css'
import 'jspdf-autotable';
import baseURL from '../../url';
import moneda from '../../moneda';
import { adminFetch } from '../../../utils/api';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import config from '@config';
// El logo se obtiene dinámicamente desde window.storeLogo


// Formatea un monto: 1200 → "$1,200.00"
const fmt = (n) => `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// productos puede venir ya parseado (array) o como string JSON
const parseProd = (p) => {
    if (Array.isArray(p)) return p;
    if (typeof p === 'string') { try { return JSON.parse(p); } catch { return []; } }
    return [];
};

const ESTADO_COLOR = {
    Pendiente: '#DAA520',
    Entregado: '#27ae60',
    Rechazado: '#e74c3c',
    Pagado:    '#2980b9',
};

export default function PedidosData() {
    const [pedidos, setPedidos] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoEstado, setNuevoEstado] = useState('');
    const [pedido, setPedido] = useState({});
    const [selectedSection, setSelectedSection] = useState('texto');

    const [filtroId, setFiltroId] = useState('');
    const [filtroMesa, setFiltroMesa] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [filtroDesde, setFiltroDesde] = useState('');
    const [filtroHasta, setFiltroHasta] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [numeroTelefono, setNumeroTelefono] = useState('');
    const [pdfViewerUrl, setPdfViewerUrl] = useState(null);
    const [pdfViewerName, setPdfViewerName] = useState('pedido.pdf');
    useEffect(() => {
        cargarPedidos();
    }, []);


    const cargarPedidos = () => {
        adminFetch(`${baseURL}/api/admin/pedidos`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setPedidos(data.pedidos || []);
            })
            .catch(error => console.error('Error al cargar pedidos:', error));
    };

    const eliminar = (idPedido) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                adminFetch(`${baseURL}/api/admin/pedidos/${idPedido}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarPedidos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar :', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setPedido(item);
        setNuevoEstado(item.estado)
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleUpdateText = (idPedido) => {
        const payload = {
            estado: nuevoEstado !== '' ? nuevoEstado : pedido.estado,
        };

        adminFetch(`${baseURL}/api/admin/pedidos/${idPedido}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarPedidos();
                    cerrarModal();
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    };



    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    const filtrados = pedidos.filter(item => {
        const idMatch = item.idPedido.toString().includes(filtroId);
        const estadoMatch = !filtroEstado || item.estado.includes(filtroEstado);
        const desdeMatch = !filtroDesde || new Date(item.createdAt) >= new Date(filtroDesde);

        // Incrementamos la fecha "hasta" en un día para que incluya la fecha seleccionada
        const adjustedHasta = new Date(filtroHasta);
        adjustedHasta.setDate(adjustedHasta.getDate() + 1);

        const hastaMatch = !filtroHasta || new Date(item.createdAt) < adjustedHasta;
        return idMatch && estadoMatch && desdeMatch && hastaMatch;
    });


    const paginate = (p) => {
        setCurrentPage(p);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const invertirOrden = () => {
        setPedidos([...pedidos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };
    const descargarExcel = () => {
        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = parseProd(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${moneda}${producto.precio} - x${producto.cantidad}  `);
            return {
                'ID Pedido': item.idPedido,
                'Estado': item.estado,
                'Nombre': item.nombre,
                'Email': item.email,
                'Telefono': item.telefono,
                'Pago': item.pago,
                'Entrega': item.entrega,
                'Nota': item.nota,
                'Productos': infoProductos.join('\n'),
                'Codigo': item.codigo,
                'Total': fmt(total),
                'Fecha': item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = fmt(totalGeneral);

        // Agregar fila con el total general
        const totalRow = {

            'ID Pedido': '',
            'Estado': '',
            'Nombre': '',
            'Email': '',
            'Telfono': '',
            'Pago': '',
            'Entrega': '',
            'Nota': '',
            'Productos': '',
            'Codigo': 'Total General:',
            'Total': formattedTotal,
            'Fecha': '',
        };

        data.push(totalRow);

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'pedidos');
        XLSX.writeFile(wb, 'pedidos.xlsx');
    };


    const descargarPDF = () => {
        const pdf = new jsPDF({ orientation: 'landscape' });
        pdf.text('Lista de Pedidos', 10, 10);

        const columns = [
            { title: 'ID Pedido', dataKey: 'idPedido' },
            { title: 'Estado', dataKey: 'estado' },
            { title: 'Nombre', dataKey: 'nombre' },
            { title: 'Telfono', dataKey: 'telefono' },
            { title: 'Pago', dataKey: 'pago' },
            { title: 'Entrega', dataKey: 'entrega' },
            { title: 'Nota', dataKey: 'nota' },
            { title: 'Productos', dataKey: 'productos' },
            { title: 'Codigo', dataKey: 'codigo' },
            { title: 'Total', dataKey: 'total' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = parseProd(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${moneda}${producto.precio} - x${producto.cantidad}  `);
            return {
                idPedido: item.idPedido,
                estado: item.estado,
                nombre: item.nombre,
                telefono: item.telefono,
                pago: item.pago,
                entrega: item.entrega,
                nota: item.nota,
                productos: infoProductos.join('\n'),
                codigo: item.codigo,
                total: fmt(total),
                createdAt: item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = fmt(totalGeneral);

        // Agregar fila con el total general
        const totalRow = {
            idPedido: '',
            estado: '',
            nombre: '',
            email: '',
            telefono: '',
            pago: '',
            entrega: '',
            nota: '',
            productos: '',
            codigo: 'Total General:',
            total: formattedTotal,
            createdAt: '',
        };

        data.push(totalRow);

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('pedidos.pdf');
    };

    // Funciones auxiliares para manejo de imágenes en PDF
    async function getBase64ImageFromUrl(url) {
        return await fetch(url)
            .then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Crear una imagen para obtener dimensiones
                    const img = new Image();
                    img.onload = () => {
                        resolve({
                            dataURL: reader.result,
                            width: img.width,
                            height: img.height
                        });
                    };
                    img.onerror = reject;
                    img.src = reader.result;
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            }));
    }

    async function convertImageToBase64(imgPath) {
        return await new Promise((resolve, reject) => {
            const img = new Image();
            img.src = imgPath;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);

                const dataURL = canvas.toDataURL('image/png');
                resolve(dataURL);
            };

            img.onerror = error => {
                reject(error);
            };
        });
    }

    const handleDownloadPDF = async () => {
        const pdf = new jsPDF({ orientation: 'landscape' });
        // ==========================================
        //  VARIABLES DE CONFIGURACIÓN
        // ==========================================
        const IMG_WIDTH_DESEADO = 18;
        const PADDING = 2;
        const MIN_ROW_HEIGHT = 20;
        const COL_WIDTH = IMG_WIDTH_DESEADO + (PADDING * 2);

        let y = 10;

        // --- Logo ---
        const logoX = 10;
        const logoY = 10;
        const logoWidth = 25;
        const logoHeight = 25;
        const storeLogo = window.storeLogo;
        if (storeLogo) {
            try {
                const logoB64 = await convertImageToBase64(storeLogo);
                pdf.addImage(logoB64, 'png', logoX, logoY, logoWidth, logoHeight);
            } catch (error) {
                console.error('Error al cargar el logo:', error);
            }
        }

        // --- Encabezados del Pedido ---
        const pedidoActual = pedido;
        const pedidoData = [
            ['ID Pedido:', `${pedidoActual.idPedido}`],
            ['Estado:', `${pedidoActual.estado}`],
            ['Cliente:', `${pedidoActual.nombre}`],
            ['Telefono:', `${pedidoActual.telefono}`],
            ['Pago:', `${pedidoActual.pago}`],
            ['Envio:', `${pedidoActual.entrega}`],
            ['Nota:', `${pedidoActual.nota}`],
            ['Cupón:', `${pedidoActual.codigo}`],
            ['Total:', fmt(pedidoActual.total)],
            ['Fecha:', `${pedidoActual.createdAt}`]
        ];

        pdf.autoTable({
            startY: y + 28,
            head: [['Detalle del pedido', 'Valor']],
            body: pedidoData,
        });

        y = pdf.lastAutoTable.finalY + 10;

        // --- Pre-carga de imágenes y Cálculo de Alturas ---
        const productosPedido = parseProd(pedidoActual.productos);
        const imagePromises = productosPedido.map(producto => {
            if (producto.imagen) {
                return getBase64ImageFromUrl(producto.imagen).catch(() => null);
            }
            return Promise.resolve(null);
        });
        const images = await Promise.all(imagePromises);

        const rowHeights = images.map(img => {
            if (img && img.width && img.height) {
                const ratio = img.height / img.width;
                const calculatedHeight = IMG_WIDTH_DESEADO * ratio;
                return Math.max(calculatedHeight + (PADDING * 2), MIN_ROW_HEIGHT);
            }
            return MIN_ROW_HEIGHT;
        });

        // Split: only first 2 products on the current page, rest on following pages
        const FIRST_COUNT = 2;
        const firstProducts = productosPedido.slice(0, FIRST_COUNT);
        const remainingProducts = productosPedido.slice(FIRST_COUNT);

        const buildRow = (producto) => ([
            producto.idProducto || '-',
            '',
            producto.titulo || '-',
            `${producto.descripcion || '-'}`.substring(0, 50),
            producto.item || '-',
            producto.cantidad || '-',
            producto.precio ? fmt(producto.precio) : '-',
            producto.precio ? fmt(producto.precio * producto.cantidad) : '-',
            producto.modulo || '-',
            producto.nivel || '-'
        ]);

        const productosDataFirst = firstProducts.map(buildRow);
        const imagesFirst = images.slice(0, firstProducts.length);
        const heightsFirst = rowHeights.slice(0, firstProducts.length);

        // Table for first (max 2) products on the same page as header
        pdf.autoTable({
            startY: y,
            head: [
                ['ID', 'IMAGEN', 'PRODUCTO', 'DESCRIPCIÓN', 'TALLA', 'CANTIDAD', 'PRECIO', 'TOTAL', 'MODULO', 'NIVEL']
            ],
            body: productosDataFirst,
            headStyles: {
                fontSize: 7,
                textColor: [255, 255, 255],
                fillColor: [41, 128, 185],
                cellPadding: 0.5,
                halign: 'center'
            },
            styles: {
                fontSize: 8,
                cellPadding: 2,
                valign: 'middle',
                halign: 'center',
                overflow: 'visible'
            },
            columnStyles: {
                0: { cellWidth: 15 },
                1: { cellWidth: COL_WIDTH },
                2: { cellWidth: 40 },
                3: { cellWidth: 40 },
            },
            didParseCell: function(data) {
                if (data.section === 'body') {
                    const uniqueRowHeight = heightsFirst[data.row.index];
                    if (uniqueRowHeight) data.row.height = uniqueRowHeight;
                }
            },
            didDrawCell: (data) => {
                if (data.column.index === 1 && data.cell.section === 'body') {
                    const imgData = imagesFirst[data.row.index];
                    if (imgData) {
                        const w = IMG_WIDTH_DESEADO;
                        const h = w * (imgData.height / imgData.width);
                        const x = data.cell.x + (data.cell.width - w) / 2;
                        const yImg = data.cell.y + (data.cell.height - h) / 2;
                        pdf.addImage(imgData.dataURL, 'PNG', x, yImg, w, h);
                    }
                }
            }
        });

        // If there are remaining products, put them on following pages
        if (remainingProducts.length > 0) {
            // Prepare remaining data arrays
            const productosDataRemaining = remainingProducts.map(buildRow);
            const imagesRemaining = images.slice(FIRST_COUNT);
            const heightsRemaining = rowHeights.slice(FIRST_COUNT);

            // Start a new page for remaining products
            pdf.addPage();

            pdf.autoTable({
                startY: 10,
                head: [
                    ['ID', 'IMAGEN', 'PRODUCTO', 'DESCRIPCIÓN', 'TALLA', 'CANTIDAD', 'PRECIO', 'TOTAL', 'MODULO', 'NIVEL']
                ],
                body: productosDataRemaining,
                headStyles: {
                    fontSize: 7,
                    textColor: [255, 255, 255],
                    fillColor: [41, 128, 185],
                    cellPadding: 0.5,
                    halign: 'center'
                },
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    valign: 'middle',
                    halign: 'center',
                    overflow: 'visible'
                },
                columnStyles: {
                    0: { cellWidth: 15 },
                    1: { cellWidth: COL_WIDTH },
                    2: { cellWidth: 40 },
                    3: { cellWidth: 40 },
                },
                didParseCell: function(data) {
                    if (data.section === 'body') {
                        const uniqueRowHeight = heightsRemaining[data.row.index];
                        if (uniqueRowHeight) data.row.height = uniqueRowHeight;
                    }
                },
                didDrawCell: (data) => {
                    if (data.column.index === 1 && data.cell.section === 'body') {
                        const imgData = imagesRemaining[data.row.index];
                        if (imgData) {
                            const w = IMG_WIDTH_DESEADO;
                            const h = w * (imgData.height / imgData.width);
                            const x = data.cell.x + (data.cell.width - w) / 2;
                            const yImg = data.cell.y + (data.cell.height - h) / 2;
                            pdf.addImage(imgData.dataURL, 'PNG', x, yImg, w, h);
                        }
                    }
                }
            });
        }

        // --- Totales ---
        const finalY = pdf.lastAutoTable.finalY + 10;
        const totalPiezas = productosPedido.reduce((acc, p) => acc + Number(p.cantidad || 0), 0);
        const totalCompra = productosPedido.reduce((acc, p) => acc + (Number(p.precio || 0) * Number(p.cantidad || 0)), 0);

        const xTotal = 60;
        const xTotalPiezas = 95;
        const xTotalCompra = 135;

        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'bold');
        pdf.text(`Totales:`, xTotal, finalY);
        pdf.text(`${totalPiezas}`, xTotalPiezas, finalY);
        pdf.text(fmt(totalCompra), xTotalCompra, finalY);

        pdf.save(`pedido_${pedido.idPedido}.pdf`);
    };

    // Igual que handleDownloadPDF pero recibe el item directamente y abre en pestaña nueva
    const verPDFDirecto = async (item) => {
        const pdf = new jsPDF({ orientation: 'landscape' });
        const IMG_WIDTH_DESEADO = 18;
        const PADDING = 2;
        const MIN_ROW_HEIGHT = 20;
        const COL_WIDTH = IMG_WIDTH_DESEADO + (PADDING * 2);
        let y = 10;

        const storeLogo = window.storeLogo;
        if (storeLogo) {
            try {
                const logoB64 = await convertImageToBase64(storeLogo);
                pdf.addImage(logoB64, 'png', 10, 10, 25, 25);
            } catch {}
        }

        pdf.autoTable({
            startY: y + 28,
            head: [['Detalle del pedido', 'Valor']],
            body: [
                ['ID Pedido:', `${item.idPedido}`],
                ['Estado:',    `${item.estado}`],
                ['Cliente:',   `${item.nombre}`],
                ['Telefono:',  `${item.telefono}`],
                ['Pago:',      `${item.pago}`],
                ['Envio:',     `${item.entrega}`],
                ['Nota:',      `${item.nota}`],
                ['Cupón:',     `${item.codigo}`],
                ['Total:',     fmt(item.total)],
                ['Fecha:',     `${item.createdAt}`],
            ],
        });

        y = pdf.lastAutoTable.finalY + 10;
        const productosPedido = parseProd(item.productos);
        const images = await Promise.all(
            productosPedido.map(p => p.imagen ? getBase64ImageFromUrl(p.imagen).catch(() => null) : Promise.resolve(null))
        );
        const rowHeights = images.map(img =>
            img?.width && img?.height
                ? Math.max(IMG_WIDTH_DESEADO * (img.height / img.width) + PADDING * 2, MIN_ROW_HEIGHT)
                : MIN_ROW_HEIGHT
        );

        const buildRow = (p) => [
            p.idProducto || '-', '', p.titulo || '-',
            `${p.descripcion || '-'}`.substring(0, 50),
            p.item || '-', p.cantidad || '-',
            p.precio ? fmt(p.precio) : '-',
            p.precio ? fmt(p.precio * p.cantidad) : '-',
            p.modulo || '-', p.nivel || '-',
        ];

        const FIRST_COUNT = 2;
        const chunks = [productosPedido.slice(0, FIRST_COUNT), productosPedido.slice(FIRST_COUNT)];
        const imgChunks = [images.slice(0, FIRST_COUNT), images.slice(FIRST_COUNT)];
        const hChunks  = [rowHeights.slice(0, FIRST_COUNT), rowHeights.slice(FIRST_COUNT)];

        chunks.forEach((chunk, ci) => {
            if (!chunk.length) return;
            if (ci > 0) pdf.addPage();
            pdf.autoTable({
                startY: ci === 0 ? y : 10,
                head: [['ID','IMAGEN','PRODUCTO','DESCRIPCIÓN','TALLA','CANTIDAD','PRECIO','TOTAL','MODULO','NIVEL']],
                body: chunk.map(buildRow),
                headStyles: { fontSize:7, textColor:[255,255,255], fillColor:[41,128,185], cellPadding:0.5, halign:'center' },
                styles: { fontSize:8, cellPadding:2, valign:'middle', halign:'center', overflow:'visible' },
                columnStyles: { 0:{cellWidth:15}, 1:{cellWidth:COL_WIDTH}, 2:{cellWidth:40}, 3:{cellWidth:40} },
                didParseCell: (d) => { if (d.section==='body' && hChunks[ci][d.row.index]) d.row.height = hChunks[ci][d.row.index]; },
                didDrawCell: (d) => {
                    if (d.column.index===1 && d.cell.section==='body') {
                        const img = imgChunks[ci][d.row.index];
                        if (img) {
                            const w=IMG_WIDTH_DESEADO, h=w*(img.height/img.width);
                            pdf.addImage(img.dataURL,'PNG', d.cell.x+(d.cell.width-w)/2, d.cell.y+(d.cell.height-h)/2, w, h);
                        }
                    }
                },
            });
        });

        const finalY = pdf.lastAutoTable.finalY + 10;
        const totalPiezas = productosPedido.reduce((a,p) => a + Number(p.cantidad||0), 0);
        const totalCompra = productosPedido.reduce((a,p) => a + Number(p.precio||0)*Number(p.cantidad||0), 0);
        pdf.setFontSize(12); pdf.setFont('helvetica','bold');
        pdf.text('Totales:', 60, finalY);
        pdf.text(`${totalPiezas}`, 95, finalY);
        pdf.text(fmt(totalCompra), 135, finalY);

        const url = pdf.output('bloburl');
        setPdfViewerName(`pedido_${item.idPedido}.pdf`);
        setPdfViewerUrl(url);
    };

    const cerrarPdfViewer = () => {
        setPdfViewerUrl(null);
    };


    return (
        <div>

            <ToastContainer />
            <div className='deFlexContent'>

                <div className='deFlex2'>

                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <input type="date" value={filtroDesde} onChange={(e) => setFiltroDesde(e.target.value)} placeholder='Desde' />
                    </div>
                    <div className='inputsColumn'>
                        <input type="date" value={filtroHasta} onChange={(e) => setFiltroHasta(e.target.value)} placeholder='Hasta' />
                    </div>

                    <div className='inputsColumn'>
                        <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Pedido' />
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                            <option value="">Estado</option>
                            <option value="Entregado">Entregado</option>
                            <option value="Rechazado">Rechazado</option>
                            <option value="Pagado">Pagado</option>
                            <option value="Pendiente">Pendiente</option>
                        </select>
                    </div>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>

                </div>

            </div>

            {/* ── Variables de paginación ── */}
            {(() => {
                const totalPages = Math.ceil(filtrados.length / itemsPerPage);
                const pageItems  = filtrados.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

                const PaginationBar = () => {
                    if (totalPages <= 1) return null;
                    const pages = [];
                    const delta = 2;
                    const range = [];
                    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) range.push(i);
                    pages.push(1);
                    if (range[0] > 2) pages.push('...');
                    pages.push(...range);
                    if (range[range.length - 1] < totalPages - 1) pages.push('...');
                    if (totalPages > 1) pages.push(totalPages);
                    return (
                        <div className="pagination">
                            <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>«</button>
                            {pages.map((p, i) => p === '...'
                                ? <span key={`d${i}`} className="pagination-dots">…</span>
                                : <button key={p} onClick={() => paginate(p)} className={currentPage === p ? 'active' : ''}>{p}</button>
                            )}
                            <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>»</button>
                        </div>
                    );
                };

                return (<>
                    {/* ── TABLA desktop ── */}
                    <div className='table-container ped-desktop-table'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Estado</th>
                                    <th>Nombre</th>
                                    {config.Cart.requiredFields.email && <th>Email</th>}
                                    <th>Teléfono</th>
                                    <th>Entrega</th>
                                    <th>Pago</th>
                                    <th>Total</th>
                                    <th>Fecha</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pageItems.map(item => (
                                    <tr key={item.idPedido}>
                                        <td>{item.idPedido}</td>
                                        <td style={{ color: ESTADO_COLOR[item.estado] || '#000' }}>{item.estado}</td>
                                        <td>{item.nombre}</td>
                                        {config.Cart.requiredFields.email && <td>{item.email}</td>}
                                        <td>{item.telefono}</td>
                                        <td>{item.entrega}</td>
                                        <td>{item.pago}</td>
                                        <td style={{ color: '#008000' }}>{fmt(item.total)}</td>
                                        <td>{item.createdAt?.slice(0, 10)}</td>
                                        <td>
                                            <div className="acciones-container">
                                                <button className='btn-eliminar' onClick={() => eliminar(item.idPedido)}><FontAwesomeIcon icon={faTrash} /></button>
                                                <button className='btn-ver' onClick={() => abrirModal(item)}><FontAwesomeIcon icon={faEye} /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* ── TARJETAS móvil ── */}
                    <div className='ped-mobile-list'>
                        {pageItems.map(item => (
                            <div key={item.idPedido} className='ped-card'>
                                <div className='ped-card-header'>
                                    <span className='ped-card-id'>Pedido #{item.idPedido}</span>
                                    <span className='ped-card-estado' style={{ color: ESTADO_COLOR[item.estado] || '#000' }}>
                                        {item.estado}
                                    </span>
                                </div>
                                <div className='ped-card-body'>
                                    <div className='ped-card-row'>
                                        <span className='ped-card-label'>Cliente</span>
                                        <span className='ped-card-value'>{item.nombre}</span>
                                    </div>
                                    <div className='ped-card-row'>
                                        <span className='ped-card-label'>Teléfono</span>
                                        <span className='ped-card-value'>{item.telefono}</span>
                                    </div>
                                    <div className='ped-card-row'>
                                        <span className='ped-card-label'>Entrega</span>
                                        <span className='ped-card-value'>{item.entrega}</span>
                                    </div>
                                    <div className='ped-card-row'>
                                        <span className='ped-card-label'>Pago</span>
                                        <span className='ped-card-value'>{item.pago}</span>
                                    </div>
                                    <div className='ped-card-row'>
                                        <span className='ped-card-label'>Total</span>
                                        <span className='ped-card-value ped-card-total'>{fmt(item.total)}</span>
                                    </div>
                                    <div className='ped-card-row'>
                                        <span className='ped-card-label'>Fecha</span>
                                        <span className='ped-card-value'>{item.createdAt?.slice(0, 10)}</span>
                                    </div>
                                </div>
                                <div className='ped-card-actions'>
                                    <button className='ped-card-btn ped-card-btn--ver' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEye} /> Ver
                                    </button>
                                    <button className='ped-card-btn ped-card-btn--pdf' onClick={() => verPDFDirecto(item)}>
                                        <FontAwesomeIcon icon={faFileAlt} /> PDF
                                    </button>
                                    <button className='ped-card-btn ped-card-btn--del' onClick={() => eliminar(item.idPedido)}>
                                        <FontAwesomeIcon icon={faTrash} /> Eliminar
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    <PaginationBar />
                </>);
            })()}
            {pdfViewerUrl && (
                <div className="pdf-viewer-overlay">
                    <iframe
                        src={pdfViewerUrl}
                        className="pdf-viewer-frame"
                        title="Visor PDF"
                    />
                    <button className="pdf-viewer-close" onClick={cerrarPdfViewer} title="Cerrar">✕</button>
                    <a
                        className="pdf-viewer-download"
                        href={pdfViewerUrl}
                        download={pdfViewerName}
                        title="Descargar PDF"
                    >
                        <FontAwesomeIcon icon={faDownload} />
                    </a>
                </div>
            )}

            {modalVisible && (
                <div className="modal ped-modal">
                    <div className="modal-content ped-modal-content">
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Pedido
                                </button>
                                <button onClick={handleDownloadPDF} className='texto'>Descargar PDF</button>
                            </div>

                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>ID Pedido</legend>
                                    <input
                                        value={pedido.idPedido}
                                        disabled

                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        value={pedido.nombre}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Email</legend>
                                    <input
                                        value={pedido.email}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Telefono</legend>
                                    <input
                                        value={pedido.telefono}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Pago</legend>
                                    <input
                                        value={pedido.pago}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Entrega</legend>
                                    <input
                                        value={pedido.entrega}
                                        disabled

                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Codigo</legend>
                                    <input
                                        value={pedido.codigo}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Nota</legend>
                                    <input
                                        value={pedido.nota}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Fecha </legend>
                                    <input
                                        value={pedido.createdAt}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Total </legend>
                                    <input
                                        value={pedido.total}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Estado</legend>
                                    <select
                                        value={nuevoEstado !== '' ? nuevoEstado : pedido.estado}
                                        onChange={(e) => setNuevoEstado(e.target.value)}
                                    >
                                        <option value={pedido.estado}>{pedido.estado}</option>
                                        <option value="Entregado">Entregado</option>
                                        <option value="Rechazado">Rechazado</option>
                                        <option value="Pagado">Pagado</option>
                                    </select>
                                </fieldset>

                            </div>
                            <div className='cardsProductData'>
                                {parseProd(pedido.productos).map(producto => (
                                    <div key={producto.titulo} className='cardProductData'>
                                        <img src={producto.imagen} alt="imagen" />
                                        <div className='cardProductDataText'>
                                            <h3>{producto.titulo}</h3>
                                            <strong>{fmt(producto.precio)} <span>x{producto.cantidad}</span></strong>
                                            <span>{producto.item}</span>

                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className='modal-footer-actions'>
                                <button className='btnPost' onClick={() => handleUpdateText(pedido.idPedido)}>Guardar</button>
                                <button className='btnCancelar' onClick={cerrarModal}>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
